<div class="about-container">
  <div class="about-hero" [@fadeInUp]>
    <div class="hero-background">
      <div class="hero-gradient"></div>
      <div class="hero-pattern"></div>
    </div>
    <div class="container">
      <div class="hero-content">
        <div class="hero-badge">
          <span>🏆</span>
          Excellence in Business
        </div>
        <h1 class="hero-title">About Aadinath Enterprises</h1>
        <h2 class="hero-subtitle">Excellence in Goods & Equipment</h2>
        <p class="hero-description">
          At Aadinath Enterprises, we bring expertise in providing top-notch Goods and Equipment. 
          Our team is dedicated to delivering exceptional solutions tailored to meet your needs.
        </p>
      </div>
    </div>
  </div>

  <!-- Company Stats Section -->
  <section class="stats-section" [@slideInLeft]>
    <div class="container">
      <div class="stats-grid" [@staggerCards]>
        <div class="stat-card" *ngFor="let stat of stats">
          <div class="stat-content">
            <span class="stat-icon">{{ stat.icon }}</span>
            <div>
              <span class="stat-number">{{ stat.number }}</span>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Story Section -->
  <section class="story-section" [@slideInRight]>
    <div class="container">
      <div class="story-content">
        <div class="story-text">
          <div class="section-badge">
            <span>📖</span>
            Our Story
          </div>
          <h2 class="section-title">Building Excellence Since Day One</h2>
          <div class="story-paragraphs">
            <p class="story-paragraph">
              We have built our reputation on delivering quality products and services that exceed expectations. 
              Our commitment to excellence drives everything we do, from sourcing the finest materials to ensuring customer satisfaction.
            </p>
            <p class="story-paragraph">
              As a trusted global supplier, we understand the importance of reliability, quality, and value. 
              That's what makes us your ideal partner for all your goods and equipment needs.
            </p>
          </div>
        </div>
        <div class="story-image">
          <img src="../../../assets/company.png" alt="Our Story" />
        </div>
      </div>
    </div>
  </section>

  <!-- Values Section -->
  <section class="values-section" [@fadeInUp]>
    <div class="container">
      <div class="section-header">
        <div class="section-badge">
          <span>⭐</span>
          Our Values
        </div>
        <h2 class="section-title">What Drives Us Forward</h2>
        <p class="section-subtitle">
          Our core values shape every decision we make and every relationship we build.
        </p>
      </div>
      <div class="values-grid" [@staggerCards]>
        <div class="value-card" *ngFor="let value of values; let i = index">
          <div class="value-number">{{ i + 1 }}</div>
          <div class="value-icon-container">
            <span class="value-icon">{{ value.icon }}</span>
            <div class="value-glow"></div>
          </div>
          <h3 class="value-title">{{ value.title }}</h3>
          <p class="value-description">{{ value.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Team Section -->
  <section class="team-section" [@slideInLeft]>
    <div class="container">
      <div class="section-header">
        <div class="section-badge">
          <span>👥</span>
          Our Team
        </div>
        <h2 class="section-title">Meet Our Leadership</h2>
        <p class="section-subtitle">
          Dedicated professionals driving innovation and excellence.
        </p>
      </div>
      <div class="team-grid" [@staggerTeam]>
        <div class="team-card" *ngFor="let member of teamMembers">
          <div class="team-image-container">
            <img class="team-image" [src]="member.image" [alt]="member.name" />
            <div class="team-overlay">
              <div class="team-social">
                <button class="social-btn" mat-fab color="primary">
                  <mat-icon>linkedin</mat-icon>
                </button>
                <button class="social-btn" mat-fab color="primary">
                  <mat-icon>email</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="team-info">
            <h4 class="team-name">{{ member.name }}</h4>
            <p class="team-position">{{ member.position }}</p>
            <p class="team-description">{{ member.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta-section" [@fadeInUp]>
    <div class="cta-background">
      <div class="cta-gradient"></div>
      <div class="cta-pattern"></div>
    </div>
    <div class="container">
      <div class="cta-content">
        <div class="cta-badge">
          <span>🚀</span>
          Ready to Get Started?
        </div>
        <h2 class="cta-title">Let's Build Something Great Together</h2>
        <p class="cta-description">
          Join over 1000+ successful businesses who trust Aadinath Enterprises for their 
          premium goods and equipment needs. Let's build something extraordinary together.
        </p>
        <div class="cta-actions">
          <button class="btn-cta" mat-raised-button>
            <mat-icon>contact_phone</mat-icon>
            Contact Us Today
            <div class="btn-glow"></div>
          </button>
          <button class="btn-cta-secondary" mat-stroked-button>
            <mat-icon>visibility</mat-icon>
            View Our Products
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
